import type { SaleAdditional } from '@src/domains/sale-items/types/saleItem';

/** The confirmed reservation card shows at most this many add-ons, then an overflow indicator. */
export const MAX_VISIBLE_ADDITIONAL_CHIPS = 3;

export interface AdditionalChips {
  visible: SaleAdditional[];
  overflowCount: number;
}

export const resolveAdditionalChips = (
  additionals: SaleAdditional[] | null | undefined,
  max: number = MAX_VISIBLE_ADDITIONAL_CHIPS,
): AdditionalChips => {
  const list = additionals ?? [];

  return {
    visible: list.slice(0, max),
    overflowCount: Math.max(list.length - max, 0),
  };
};
